module.exports = __webpack_public_path__ + "img/service1.711e3850.png";